import { StrandLossesManagerPage } from "./StrandLossesManagerPage";

const StrandLossesManager = () => <StrandLossesManagerPage />;

export default StrandLossesManager;
